import React from "react";

function LiveTargetIcon() {
  return (
    <svg width="26" height="28" viewBox="0 0 26 28" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="4" y="5" width="18" height="18" rx="9" fill="white" />
      <rect x="8.5" y="9.5" width="9" height="9" rx="4.5" fill="white" stroke="#34C759" stroke-width="3" />
    </svg>

  );
}

export default LiveTargetIcon;
